import { FormHelperText } from '@material-ui/core';
import SignatureControl from 'bz-core-controls/controls/general/signature-control';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

interface IProps {
  name: string;
  disabled?: boolean;
  errorText?: string;
  defaultValue?: string;
}

const FormSignature: React.FC<IProps> = React.memo(
  ({ name, defaultValue, errorText, disabled = false }) => {
    const { control, setValue, trigger } = useFormContext();
    return (
      <Controller
        defaultValue={defaultValue}
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <>
            <SignatureControl
              readOnly={disabled}
              strokeWidth={0}
              warning={false}
              onChange={(signature) => {
                onChange(signature);
                setValue('signature', signature);
                trigger('signature');
              }}
              strokeColor={'black'}
              value={value}
            />
            {errorText && <FormHelperText>{errorText}</FormHelperText>}
          </>
        )}
      />
    );
  }
);

FormSignature.displayName = 'FormSignature';

export default FormSignature;
